<form [formGroup]="myForm" (ngSubmit)="onSubmit()">
  <mat-horizontal-stepper class="loaded-content" [class.blurred]="saving" linear #stepper> 
    <mat-step [stepControl]="myForm" [editable]="isEditable">
      <ng-template matStepLabel>{{ (isEdit ? 'FARM.EDIT_DATA_FARM' : 'FARM.PUT_DATA_FARM') | translate }}</ng-template>
      <app-step1 [formParent]="myForm" [ubication]="ubication" *ngIf="showStep1"
          (uploadImage)="addImage($event)"></app-step1>
      <div>
        <button mat-button matStepperNext type="button" (click)="showStep2 = true">{{ 'SYSTEM.NEXT' | translate }}</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="myForm" [editable]="isEditable">
        <ng-template matStepLabel>{{ (isEdit ? 'FARM.EDIT_POINTS_FARM' : 'FARM.SELECT_POINTS_FARM') | translate }}</ng-template>     
        <app-step2 [formParent]="myFormGeometry" [formParentStepOne]="myForm" [allFarms]="allFarms" [farmId]="farmId" [ubication]="ubication" *ngIf="showStep2"></app-step2>
        <div>
          <button mat-button matStepperPrevious type="button">{{ 'SYSTEM.BACK' | translate }}</button>
          <button mat-button matStepperNext type="button" [disabled]="myFormGeometry.get('geometry').value == undefined || myFormGeometry.get('geometry').value === ''">{{ 'SYSTEM.NEXT' | translate }}</button>
        </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'SYSTEM.DONE' | translate }}</ng-template>
      <div>
        <app-step3 [formParent]="myForm" [ubication]="ubication"></app-step3>
        <button mat-button matStepperPrevious type="button">{{ 'SYSTEM.BACK' | translate }}</button>
        <button type="submit" mat-button [disabled]="clicked">{{ 'FARM.SAVE_FARM' | translate }}</button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</form>

  <ng-template #template>
    <div class="modal-header">
      <h4 class="modal-title pull-left"> {{ 'FARM.INFO_FARM' | translate }}</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      {{ 'FARM.CREATED_FARM' | translate }}
    </div>
  </ng-template>